module.exports = __webpack_public_path__ + "ff8f83bf8e7d5bad0fb6472d3ffd914f.pdf";